import { render, staticRenderFns } from "./GroupOverviewGrid.vue?vue&type=template&id=2344e6a8&scoped=true"
import script from "./GroupOverviewGrid.vue?vue&type=script&lang=js"
export * from "./GroupOverviewGrid.vue?vue&type=script&lang=js"
import style0 from "./GroupOverviewGrid.vue?vue&type=style&index=0&id=2344e6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344e6a8",
  null
  
)

export default component.exports